module.exports = __webpack_public_path__ + "img/cert7.043816f9.png";